import Loader from "@components/Loader"
import { useState } from "react";

export const MapContainer = (props) => {
    const hideLoader = function(){
        setIsLoadedImg(true);
    }
    const [isLoadedImg, setIsLoadedImg] = useState(false);

    return (
        <div className='map-container container-fluid-boss'>
            <div className='row'>
                <div className='container-row'>
                    <Loader classes={"align-center " + (isLoadedImg ? " hide" : " show")}/>
                    <img className='popup-map' onLoad={hideLoader} alt='map' src={props.link}></img>
                </div>
            </div>
        </div>
    )
}